import { c as _c } from "react/compiler-runtime";
import { useFormikContext } from 'formik';
import isEmpty from '../../../utils/isEmpty';
import { Div } from '../helpers/StyledUtils';
import InputError from './Fields/Input/InputError';
import { ReactNode } from 'react';

// Shows form errors, or errors for any field anywhere in the form.
// It can be rendered anywhere in the form, but it's usually rendered at the bottom of the form.
const FormError = t0 => {
  const $ = _c(8);
  const {
    error_limit: t1,
    field,
    children
  } = t0;
  const error_limit = t1 === undefined ? 1 : t1;
  const {
    errors
  } = useFormikContext();
  if (process.env.NODE_ENV !== "production" && error_limit <= 0) {
    throw new Error("You set error_limit to 0 or less. This is probably not what you want, since it will never show any errors.");
  }
  let t2;
  if ($[0] !== field) {
    t2 = typeof field === "string" ? [field] : field;
    $[0] = field;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const fields = t2;
  if (isEmpty(errors)) {
    return null;
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      t: 2
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== error_limit || $[5] !== errors || $[6] !== fields) {
    t4 = <Div m={t3}>{Object.entries(errors).filter(t5 => {
        const [field_0, error] = t5;
        return (!Array.isArray(field_0) || fields && fields.includes(field_0)) && typeof error === "string";
      }).slice(0, error_limit).map(t6 => {
        const [field_1, error_0] = t6;
        return <><InputError>{error_0}</InputError>{children?.(field_1)}</>;
      })}</Div>;
    $[3] = children;
    $[4] = error_limit;
    $[5] = errors;
    $[6] = fields;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default FormError;